import { Injectable } from '@angular/core';
import { IClientSignField } from '@app/transaction-builder/model/sign-field.model';
import { ITransactionData } from '@app/transaction-builder/model/transaction-data.model';
import { ClientDocumentRelation } from 'ngx-mat-esign360';
import { ITxFormClientData } from '../model/transaction-form-data.model';

@Injectable({
  providedIn: 'root',
})
export class SignersService {
  constructor() {}

  extractDocSignersFromTxData(
    transactionData: ITransactionData,
    documentCid: string
  ): ITxFormClientData[] {
    const documentIndex = transactionData.documentsData.findIndex(
      (docData) => docData.cid === documentCid
    );
    const docRelations =
      transactionData.formData.documents.clientsToDocs.find(
        (_, index) => index === documentIndex
      ) || [];

    return this.filterDocumentSigners(transactionData.formData.clients, docRelations);
  }

  filterDocumentSigners(
    clients: ITxFormClientData[],
    docRelations: ClientDocumentRelation[]
  ): ITxFormClientData[] {
    const mustSignSigners: ITxFormClientData[] = [];

    for (let i = 0; i < docRelations.length; i++) {
      if (docRelations[i] === ClientDocumentRelation.MustSign) {
        mustSignSigners.push(clients[i]);
      }
    }
    return mustSignSigners;
  }

  doAllSignersHaveSignFields(transactionData: ITransactionData): boolean {
    if (Object.keys(transactionData.signFieldsByDocument).length === 0) {
      return false;
    }

    return Object.keys(transactionData.signFieldsByDocument).every((documentName) => {
      const signFields = transactionData.signFieldsByDocument[documentName];
      const signers = this.extractDocSignersFromTxData(transactionData, documentName);

      return signers.every((signer) => this.doesSignerHaveSignField(signer, signFields));
    });
  }

  getSignFieldsForSigner(
    signer: ITxFormClientData,
    signFields: IClientSignField[]
  ): IClientSignField[] {
    return signFields.filter((signField) => signField.client.cid === signer.cid);
  }

  doesSignerHaveSignField(signer: ITxFormClientData, signFields: IClientSignField[]): boolean {
    return signFields.some((signField) => signField.client.cid === signer.cid);
  }
}
